export const getters = {
  fundingSourceTypes(state) {
    return state.fundingSourceTypes;
  },
  fundingSourceTypesMap(state) {
    return state.fundingSourceTypes.reduce((map, type) => {
      map[type.value] = type.text;
      return map;
    }, {});
  },
};
